import { isEmpty } from 'lodash/fp';

import { CustomerActionType } from '../../../../actions/customer';
import DiversifiedHero from '../../components/diversified-hero';
import HeroOfferSection from '../../components/hero-offer-section';
import HeroSection from '../../components/hero-section';
import ProductPropType from '../../../../types/product';
import WelcomeBackHeroSection from '../../components/welcome-back-hero';
import type { HeroSectionProps } from '../../types';
import type { Offer, Placeholder } from '../../../../components/offers/types';

type HomeHeroProps = {
  diversifiedHeroProps: HeroSectionProps;
  heroSectionProps: HeroSectionProps;
  isAfterHydration: boolean;
  lastViewedProduct?: ProductPropType;
  memberNumber?: string;
  offerProps: {
    activeOffers?: Offer[];
    placeholders?: Placeholder[];
  };
  actions: CustomerActionType;
};

const getHomeHero = ({
  diversifiedHeroProps,
  heroSectionProps,
  lastViewedProduct,
  isAfterHydration,
  memberNumber,
  offerProps,
  actions,
}: HomeHeroProps) => {
  const heroOfferSection = <HeroOfferSection lastViewedProduct={lastViewedProduct} {...offerProps} />;

  if (isAfterHydration) {
    if (memberNumber) {
      return <DiversifiedHero {...diversifiedHeroProps} />;
    }

    if (!isEmpty(lastViewedProduct)) {
      return <WelcomeBackHeroSection heroOfferSection={heroOfferSection} lastViewedProduct={lastViewedProduct} />;
    }
  }

  return <HeroSection {...heroSectionProps} heroOfferSection={heroOfferSection} actions={actions} />;
};

export default getHomeHero;
